import { create } from 'zustand';
import { persist } from 'zustand/middleware';

function generateDatePlusThreeMonths() {
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() + 3);

  const year = currentDate.getFullYear().toString();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');

  return {
    year,
    month,
    day,
  };
}

export const useStore = create(
  persist(
    (set, get) => ({
      pageAnswers: {},
      setPageAnswer: (pageId, data) =>
        set((state) => ({
          pageAnswers: {
            ...state.pageAnswers,
            [pageId]: data,
          },
        })),
      visitedPages: [],
      addVisitedPage: (page) => {
        const currentVisited = get().visitedPages;
        if (currentVisited[currentVisited.length - 1] !== page) {
          set({ visitedPages: [...currentVisited, page] });
        }
      },
      getPreviousPage: () => {
        const visited = get().visitedPages;
        const current = get().currentPage;
        const currentIndex = visited.indexOf(current);
        return currentIndex > 0 ? visited[currentIndex - 1] : null;
      },
      savedOnboarding: false,
      setSavedOnboarding: (savedOnboarding) => set(() => ({ savedOnboarding })),
      showDownSale: false,
      setShowDownsale: (showDownSale) => set(() => ({ showDownSale })),
      nativeLanguage: '',
      setNativeLanguage: (nativeLanguage) => set(() => ({ nativeLanguage })),
      targetLanguage: '',
      setTargetLanguage: (targetLanguage) => set(() => ({ targetLanguage })),

      
      bmi: null,
      setBmi: (bmi) => set(() => ({ bmi })),
      userId: undefined,
      setUserId: (userId) => set(() => ({ userId })),
      prevPage: '',
      currentPage: '',
      setPage: (newPage) =>
        set((state) => ({
          prevPage: state.currentPage,
          currentPage: newPage,
        })),
      authTokens: null,
      authTokensExpiry: null,
      setAuthTokens: (tokens) =>
        set(() => ({
          authTokens: tokens,
          authTokensExpiry: Date.now() + 60 * 60 * 1000,
        })),

      clearAuthTokens: () =>
        set(() => ({
          authTokens: null,
          authTokensExpiry: null,
        })),
      usedGlp: undefined,
      currentlyTaking: undefined,
      semaglutideDose: undefined,
      howFamiliarGlp: undefined,
      sideEffects: [],
      noticedMuscle: undefined,
      gender: undefined,
      eatHours: { start: undefined, finish: undefined },
      eatingWindow: null,
      born: undefined,
      birthDate: undefined,
      name: undefined,
      height: {
        ft: undefined,
        type: 'ft',
      },
      weight: {
        kg: undefined,
        type: 'kg',
      },
      loosGoal: undefined,
      goalRightNow: undefined,
      bodyType: undefined,
      mostDifficult: undefined,
      usualBreakfast: undefined,
      additionalGoals: [],
      lastPeriod: undefined,
      yourBiggestConcern: [],
      idealWeight: {
        value: undefined,
        type: 'kg',
      },
      motivation: undefined,
      when: generateDatePlusThreeMonths(),
      email: undefined,
      mealsCount: undefined,
      prepareMeals: [],
      dailyDrinks: [],
      snackCravings: [],
      typicallyTriggers: [],
      crabDense: [],
      preferences: undefined,
      exclude: [],
      topicOfWeightLoss: undefined,
      caloriesRelationship: undefined,
      healthConcerns: [],
      nutritionHabits: [],
      habits: [],
      typicalLunch: [],
      vegetableIntake: [],
      workSchedule: [],
      yourLifestyle: [],
      goForWalks: undefined,
      workOut: [],
      sleepPerNight: [],
      improveYourSleep: [],
      children: undefined,
      nutrients: undefined,
      changeMotivation: undefined,
      statement: undefined,
      statementSecond: undefined,
      statementThird: undefined,
      statementFourth: undefined,
      statementFifth: undefined,
      statementSixth: undefined,
      statementSeventh: undefined,
      statementEighth: undefined,
      statementNinth: undefined,
      statementTenth: undefined,
      startTraining: undefined,
      atThisMoment: undefined,
      thinkOfIdealWeight: [],
      struggle: [],
      uncertain: [],
      eatingHabits: [],
      energyLevel: undefined,
      thoughts: undefined,
      showPhotoProcessing: false,
      photoProcessingUuid: '',
      photoError: false,
      generatedPhotoUrl: null,
      imageUrl: '',
      bodyImageUrl: '',
      bodyImageFile: '',
      bodyScanError: false,
      existTimeoutId: Number,
      skippedPages: [],
      trialPrice: '',
      youGuessedCount: 0,
      bodyAreas: [],
      dailyActivity: undefined,
      dairy: undefined,
      dietFamiliarity: undefined,
      energyLevels: undefined,
      idealWeightTime: undefined,
      mainReason: undefined,
      meatRelationship: undefined,
      weightChange: undefined,
      breakfast: undefined,
      budgetPriority: undefined,
      foodShopping: undefined,
      ingredientPreference: undefined,
      snacks: undefined,
      dailySteps: undefined,
      chooseBreakfast: [],
      chooseLunch: [],
      chooseSnack: [],
      chooseDinner: [],
      cookingTime: undefined,
      groceryBudget: undefined,
      eatLessMoveMore: undefined,
      calorieTracking: undefined,
      dislikeDiets: undefined,
      restartAfterSlip: undefined,
      fastingExperience: undefined,
      fastingDetails: undefined,
      mealplanExperience: undefined,
      offplanBehavior: undefined,
      favoriteFoods: [],
      foodRelationship: undefined,
      goalMain: undefined,
      goalWeightlossReason: undefined,
      goalAdditional: [],
      weightlossExperience: undefined,
      weightlossChallenges: [],
      weightGainReason: undefined,
      previousAttempt: undefined,
      whatsDifferentThisTime: undefined,
      successVisualization: undefined,
      calorieTrackingBefore: undefined,
      calorieTrackingMethod: undefined,
      calorieTrackingApp: undefined,
      calorieDifficulty: undefined,
      calorieEducation: undefined,
      stayOnTrack: [],
      goalMotivation: undefined,
      startEmotions: undefined,
      usageTime: undefined,
      weekendsHard: undefined,
      triggersEating: undefined,
      improveHabits: [],
      loggingHabits: undefined,
      activityPlan: [],
      progressTracking: [],
      rewards: [],
      workHours: undefined,
      socialEating: undefined,
      stayMotivated: undefined,
      weekendMore: undefined,
      weekendDays: undefined,

      snackTime: undefined,
      morningHabits: undefined,
      selfEvaluation: undefined,
      foodMythsSweets: undefined,
      foodMythsPizza: undefined,
      foodMythsEvening: undefined,
      healthyEating: undefined,
      barriers: [],
      emotionalEating: [],
      faceScanBase64: '',
      faceData: null,
      setFaceData: (data) => set({ faceData: data }),
      setUsedGlp: (usedGlp) => set(() => ({ usedGlp: usedGlp })),
      setCurrentlyTaking: (currentlyTaking) => set(() => ({ currentlyTaking: currentlyTaking })),
      setSemaglutideDose: (semaglutideDose) => set(() => ({ semaglutideDose: semaglutideDose })),
      setHowFamiliarGlp: (howFamiliarGlp) => set(() => ({ howFamiliarGlp: howFamiliarGlp })),
      setSideEffects: (sideEffects) => set(() => ({ sideEffects: sideEffects })),
      setNoticedMuscle: (noticedMuscle) => set(() => ({ noticedMuscle: noticedMuscle })),
      setGender: (gender) => set(() => ({ gender: gender })),
      setEatHours: (eatHours) => set(() => ({ eatHours: eatHours })),
      setEatingWindow: (eatingWindow) => set(() => ({ eatingWindow: eatingWindow })),
      setBorn: (born) => set(() => ({ born: born })),
      setBirthDate: (birthDate) => set(() => ({ birthDate: birthDate })),
      setName: (name) => set(() => ({ name: name })),
      setHeight: (height) => set(() => ({ height: height })),
      setWeight: (weight) => set(() => ({ weight: weight })),
      setLoosGoal: (loosGoal) => set(() => ({ loosGoal: loosGoal })),
      setGoalRightNow: (goalRightNow) => set(() => ({ goalRightNow: goalRightNow })),
      setBodyType: (bodyType) => set(() => ({ bodyType: bodyType })),
      setMostDifficult: (mostDifficult) => set(() => ({ mostDifficult: mostDifficult })),
      setUsualBreakfast: (usualBreakfast) => set(() => ({ usualBreakfast: usualBreakfast })),
      setAdditionalGoals: (additionalGoals) => set(() => ({ additionalGoals: additionalGoals })),
      setLastPeriod: (lastPeriod) => set(() => ({ lastPeriod: lastPeriod })),
      setYourBiggestConcern: (yourBiggestConcern) =>
        set(() => ({ yourBiggestConcern: yourBiggestConcern })),
      setIdealWeight: (idealWeight) => set(() => ({ idealWeight: idealWeight })),
      setMotivation: (motivation) => set(() => ({ motivation: motivation })),
      setWhen: (when) => set(() => ({ when: when })),
      setEmail: (email) => set(() => ({ email: email })),
      setMealsCount: (mealsCount) => set(() => ({ mealsCount: mealsCount })),
      setPrepareMeals: (prepareMeals) => set(() => ({ prepareMeals: prepareMeals })),
      setDailyDrinks: (dailyDrinks) => set(() => ({ dailyDrinks: dailyDrinks })),
      setSnackCravings: (snackCravings) => set(() => ({ snackCravings: snackCravings })),
      setTypicallyTriggers: (typicallyTriggers) =>
        set(() => ({ typicallyTriggers: typicallyTriggers })),
      setCrabDense: (crabDense) => set(() => ({ crabDense: crabDense })),
      setPreferences: (preferences) => set(() => ({ preferences: preferences })),
      setExclude: (exclude) => set(() => ({ exclude: exclude })),
      setTopicOfWeightLoss: (topicOfWeightLoss) =>
        set(() => ({ topicOfWeightLoss: topicOfWeightLoss })),
      setCaloriesRelationship: (caloriesRelationship) =>
        set(() => ({ caloriesRelationship: caloriesRelationship })),
      setHealthConcerns: (healthConcerns) => set(() => ({ healthConcerns: healthConcerns })),
      setNutritionHabits: (nutritionHabits) => set(() => ({ nutritionHabits: nutritionHabits })),
      setHabits: (habits) => set(() => ({ habits: habits })),
      setTypicalLunch: (typicalLunch) => set(() => ({ typicalLunch: typicalLunch })),
      setVegetableIntake: (vegetableIntake) => set(() => ({ vegetableIntake: vegetableIntake })),
      setWorkSchedule: (workSchedule) => set(() => ({ workSchedule: workSchedule })),
      setYourLifestyle: (yourLifestyle) => set(() => ({ yourLifestyle: yourLifestyle })),
      setGoForWalks: (goForWalks) => set(() => ({ goForWalks: goForWalks })),
      setWorkOut: (workOut) => set(() => ({ workOut: workOut })),
      setSleepPerNight: (sleepPerNight) => set(() => ({ sleepPerNight: sleepPerNight })),
      setImproveYourSleep: (improveYourSleep) =>
        set(() => ({ improveYourSleep: improveYourSleep })),
      setChildren: (children) => set(() => ({ children: children })),
      setNutrients: (nutrients) => set(() => ({ nutrients: nutrients })),
      setChangeMotivation: (changeMotivation) =>
        set(() => ({ changeMotivation: changeMotivation })),
      setStatement: (statement) => set(() => ({ statement: statement })),
      setStatementSecond: (statementSecond) => set(() => ({ statementSecond: statementSecond })),
      setStatementThird: (statementThird) => set(() => ({ statementThird: statementThird })),
      setStatementFourth: (statementFourth) => set(() => ({ statementFourth: statementFourth })),
      setStatementFifth: (statementFifth) => set(() => ({ statementFifth: statementFifth })),
      setStatementSixth: (statementSixth) => set(() => ({ statementSixth: statementSixth })),
      setStatementSeventh: (statementSeventh) =>
        set(() => ({ statementSeventh: statementSeventh })),
      setStatementEighth: (statementEighth) => set(() => ({ statementEighth: statementEighth })),
      setStatementNinth: (statementNinth) => set(() => ({ statementNinth: statementNinth })),
      setStatementTenth: (statementTenth) => set(() => ({ statementTenth: statementTenth })),
      setStartTraining: (startTraining) => set(() => ({ startTraining: startTraining })),
      setAtThisMoment: (atThisMoment) => set(() => ({ atThisMoment: atThisMoment })),
      setThinkOfIdealWeight: (thinkOfIdealWeight) =>
        set(() => ({ thinkOfIdealWeight: thinkOfIdealWeight })),
      setStruggle: (struggle) => set(() => ({ struggle: struggle })),
      setUncertain: (uncertain) => set(() => ({ uncertain: uncertain })),
      setEatingHabits: (eatingHabits) => set(() => ({ eatingHabits: eatingHabits })),
      setEnergyLevel: (energyLevel) => set(() => ({ energyLevel: energyLevel })),
      setThoughts: (thoughts) => set(() => ({ thoughts: thoughts })),
      setShowPhotoProcessing: (showPhotoProcessing) => set(() => ({ showPhotoProcessing })),
      setPhotoProcessingUuid: (photoProcessingUuid) => set(() => ({ photoProcessingUuid })),
      setPhotoError: (photoError) => set(() => ({ photoError })),
      setGeneratedPhotoUrl: (url) => set({ generatedPhotoUrl: url }),
      setExistTimeoutId: (existTimeoutId) => set(() => ({ existTimeoutId })),
      setImageUrl: (imageUrl) => set(() => ({ imageUrl: imageUrl })),
      setBodyImageFile: (bodyImageFile) => set(() => ({ bodyImageFile: bodyImageFile })),
      setBodyImageUrl: (bodyImageUrl) => set(() => ({ bodyImageUrl: bodyImageUrl })),
      setBodyScanError: (bodyScanError) => set(() => ({ bodyScanError: bodyScanError })),
      setSkippedPages: (skippedPages) => set(() => ({ skippedPages: skippedPages })),
      addSkippedPage: (page) =>
        set((state) => {
          if (state.skippedPages.includes(page)) return state;
          return {
            skippedPages: [...state.skippedPages, page],
          };
        }),
      removeSkippedPage: (page) =>
        set((state) => ({
          skippedPages: state.skippedPages.filter((p) => p !== page),
        })),
      setTrialPrice: (trialPrice) => set(() => ({ trialPrice: trialPrice })),
      setYouGuessedCount: (newCount) => set({ youGuessedCount: newCount }),
      setBodyAreas: (bodyAreas) => set(() => ({ bodyAreas: bodyAreas })),
      setDailyActivity: (dailyActivity) => set(() => ({ dailyActivity: dailyActivity })),
      setDairy: (dairy) => set(() => ({ dairy: dairy })),
      setDietFamiliarity: (dietFamiliarity) => set(() => ({ dietFamiliarity: dietFamiliarity })),
      setEnergyLevels: (energyLevels) => set(() => ({ energyLevels: energyLevels })),
      setIdealWeightTime: (idealWeightTime) => set(() => ({ idealWeightTime: idealWeightTime })),
      setMainReason: (mainReason) => set(() => ({ mainReason: mainReason })),
      setMeatRelationship: (meatRelationship) =>
        set(() => ({ meatRelationship: meatRelationship })),
      setWeightChange: (weightChange) => set(() => ({ weightChange: weightChange })),
      setBreakfast: (breakfast) => set(() => ({ breakfast: breakfast })),
      setBudgetPriority: (budgetPriority) => set(() => ({ budgetPriority: budgetPriority })),
      setFoodShopping: (foodShopping) => set(() => ({ foodShopping: foodShopping })),
      setIngredientPreference: (ingredientPreference) =>
        set(() => ({ ingredientPreference: ingredientPreference })),
      setSnacks: (snacks) => set(() => ({ snacks: snacks })),
      setDailySteps: (dailySteps) => set(() => ({ dailySteps: dailySteps })),
      setChooseBreakfast: (chooseBreakfast) => set(() => ({ chooseBreakfast: chooseBreakfast })),
      setChooseLunch: (chooseLunch) => set(() => ({ chooseLunch: chooseLunch })),
      setChooseSnack: (chooseSnack) => set(() => ({ chooseSnack: chooseSnack })),
      setChooseDinner: (chooseDinner) => set(() => ({ chooseDinner: chooseDinner })),
      setCookingTime: (cookingTime) => set(() => ({ cookingTime: cookingTime })),
      setGroceryBudget: (groceryBudget) => set(() => ({ groceryBudget: groceryBudget })),
      setEatLessMoveMore: (eatLessMoveMore) => set(() => ({ eatLessMoveMore: eatLessMoveMore })),
      setCalorieTracking: (calorieTracking) => set(() => ({ calorieTracking: calorieTracking })),
      setDislikeDiets: (dislikeDiets) => set(() => ({ dislikeDiets: dislikeDiets })),
      setRestartAfterSlip: (restartAfterSlip) =>
        set(() => ({ restartAfterSlip: restartAfterSlip })),
      setFastingExperience: (fastingExperience) =>
        set(() => ({ fastingExperience: fastingExperience })),
      setFastingDetails: (fastingDetails) => set(() => ({ fastingDetails: fastingDetails })),
      setMealplanExperience: (mealplanExperience) =>
        set(() => ({ mealplanExperience: mealplanExperience })),
      setOffplanBehavior: (offplanBehavior) => set(() => ({ offplanBehavior: offplanBehavior })),
      setFavoriteFoods: (favoriteFoods) => set(() => ({ favoriteFoods: favoriteFoods })),
      setFoodRelationship: (foodRelationship) =>
        set(() => ({ foodRelationship: foodRelationship })),
      setGoalMain: (goalMain) => set(() => ({ goalMain })),
      setGoalWeightlossReason: (goalWeightlossReason) => set(() => ({ goalWeightlossReason })),
      setGoalAdditional: (goalAdditional) => set(() => ({ goalAdditional })),
      setWeightlossExperience: (weightlossExperience) => set(() => ({ weightlossExperience })),
      setWeightlossChallenges: (weightlossChallenges) => set(() => ({ weightlossChallenges })),
      setWeightGainReason: (weightGainReason) => set(() => ({ weightGainReason })),
      setPreviousAttempt: (previousAttempt) => set(() => ({ previousAttempt })),
      setWhatsDifferentThisTime: (whatsDifferentThisTime) =>
        set(() => ({ whatsDifferentThisTime })),
      setSuccessVisualization: (successVisualization) => set(() => ({ successVisualization })),
      setCalorieTrackingBefore: (calorieTrackingBefore) => set(() => ({ calorieTrackingBefore })),
      setCalorieTrackingMethod: (calorieTrackingMethod) => set(() => ({ calorieTrackingMethod })),
      setCalorieTrackingApp: (calorieTrackingApp) => set(() => ({ calorieTrackingApp })),
      setCalorieDifficulty: (calorieDifficulty) => set(() => ({ calorieDifficulty })),
      setCalorieEducation: (calorieEducation) => set(() => ({ calorieEducation })),
      setStayOnTrack: (stayOnTrack) => set(() => ({ stayOnTrack })),
      setGoalMotivation: (goalMotivation) => set(() => ({ goalMotivation })),
      setStartEmotions: (startEmotions) => set(() => ({ startEmotions })),
      setUsageTime: (usageTime) => set(() => ({ usageTime })),
      setWeekendsHard: (weekendsHard) => set(() => ({ weekendsHard })),
      setTriggersEating: (triggersEating) => set(() => ({ triggersEating })),
      setImproveHabits: (improveHabits) => set(() => ({ improveHabits })),
      setLoggingHabits: (loggingHabits) => set(() => ({ loggingHabits })),
      setActivityPlan: (activityPlan) => set(() => ({ activityPlan })),
      setProgressTracking: (progressTracking) => set(() => ({ progressTracking })),
      setRewards: (rewards) => set(() => ({ rewards })),
      setWorkHours: (workHours) => set(() => ({ workHours })),
      setSocialEating: (socialEating) => set(() => ({ socialEating })),
      setStayMotivated: (stayMotivated) => set(() => ({ stayMotivated })),
      setWeekendMore: (weekendMore) => set(() => ({ weekendMore })),
      setWeekendDays: (weekendDays) => set(() => ({ weekendDays })),

      setSnackTime: (snackTime) => set(() => ({ snackTime: snackTime })),
      setMorningHabits: (morningHabits) => set(() => ({ morningHabits: morningHabits })),
      setSelfEvaluation: (selfEvaluation) => set(() => ({ selfEvaluation: selfEvaluation })),
      setFoodMythsSweets: (foodMythsSweets) => set(() => ({ foodMythsSweets: foodMythsSweets })),
      setFoodMythsPizza: (foodMythsPizza) => set(() => ({ foodMythsPizza: foodMythsPizza })),
      setFoodMythsEvening: (foodMythsEvening) =>
        set(() => ({ foodMythsEvening: foodMythsEvening })),
      setHealthyEating: (healthyEating) => set(() => ({ healthyEating: healthyEating })),
      setBarriers: (barriers) => set(() => ({ barriers: barriers })),
      setEmotionalEating: (emotionalEating) => set(() => ({ emotionalEating: emotionalEating })),
      setFaceScanBase64: (faceScanBase64) => set(() => ({ faceScanBase64 })),
    }),
    {
      name: 'local-store',
      getStorage: () => localStorage,
      partialize: (state) => {
        const { faceScanBase64, authTokensExpiry, ...stateToSave } = state;
        return stateToSave;
      },
    }
  )
);
